import { Pill } from "@jelly/ui";
import React, { useState } from "react";

import styles from "./Page01.module.scss";
import Slider from "@src/lms/jelly/extensions/components/slider/Slider";
import { Fig21, Fig22 } from "@src/lms/jelly/extensions/layouts/_lesson/lesson05/images";
// import classNames from "classnames";

export interface Lesson0105Page01Props {
  azimuthLabel: string;
  elevationLabel: string;
  distanceLabel: string;
}

export const Lesson0105Page02: React.FC<Lesson0105Page01Props> = ({ azimuthLabel, elevationLabel, distanceLabel }) => {
  const [azimuth, setAzimuth] = useState(50);
  const [elevation, setElevation] = useState(0);
  const [distance, setDistance] = useState(100);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.imagesRow}>
        <Fig21 a={azimuth / 100} e={elevation / 100} d={distance / 100} />
        <div className={styles.separator}></div>
        <Fig22 a={azimuth / 100} e={elevation / 100} d={distance / 100} />
      </div>
      <div className={styles.slidersRow}>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {azimuthLabel}
          </Pill>
          <Slider theme="primary" value={azimuth} min={0} max={100} onChange={(val) => setAzimuth(val)} />
        </div>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {elevationLabel}
          </Pill>
          <Slider theme="primary" value={elevation} min={0} max={100} onChange={(val) => setElevation(val)} />
        </div>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {distanceLabel}
          </Pill>
          <Slider theme="primary" value={distance} min={0} max={100} onChange={(val) => setDistance(val)} />
        </div>
      </div>
    </div>
  );
};
